import { currentLang } from "i18n";

// Locale-aware "Senin, Selasa, dan Rabu" / "Monday, Tuesday, and Wednesday"
// joining, via the standard Intl.ListFormat API rather than hand-rolled
// comma logic — correctly generalizes past the 2-item case ("Sabtu dan
// Minggu") to three or more without any special-casing here.
export const formatNaturalList = (items: string[]): string =>
  new Intl.ListFormat(currentLang(), { style: "long", type: "conjunction" }).format(items);
